import {useState, useRef, useEffect} from 'react';
import {TextareaAutosize, TextField, Box, Grid, IconButton, Stack, Tooltip, Fade, Typography, ClickAwayListener} from "@mui/material";
import {useDrag, DragPreviewImage} from 'react-dnd'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Badge from '@mui/material/Badge';
// import ResizeObserver from 'rc-resize-observer';
import {ResizableBox} from 'react-resizable';
import {getResponsiveFontSize} from "../../utils/FontUtil";
import {elementTypes, dragSourceType, initialDragElements, minElementHeight, minElementWidth} from "../../common/staticVariables";
import QRCodeGenerator from 'qrcode';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getAdjustedHeight, getAdjustedWidth } from "../../utils/AspectRatioUtil";
import { useDebounce } from "../../hooks/useDebounce";
import he from 'date-fns/esm/locale/he/index.js';
import QRCode from 'react-qr-code';
import { ptToPx } from '../../utils/UnitConverterUtil';
import { isValidURL } from '../../utils/StringUtil';
import OVCodeSealImg from "../../images/ovcode-seal.png";
import { generateQRCodeBase64 } from "../../utils/QRCodeUtil";




const qrcode = "data:image/png;base64,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"

const TemplateElementFloatingPanel = ({element_type, removeElement, currentClickedElementId, openChangeSignatureFromParent, openChangeSignature, setOpenAddSignature, 
    element, sendTempSignatureToParent, setIsDraggingUsingToolbarDragItem, elementToolbarRef, setDuplicateElementData, 
    setTextElementFontSize, handleOnClickAwayElement, setCurrentESignatureUserId, setCurrentESignatureB2CId}) => {

    const [disableUpFontSize, setDisableUpFontSize] = useState(element.font_size >= 64 ? true : false)
    const [disableDownFontSize, setDisableDownFontSize] = useState(element.font_size <= 8 ? true : false)

    useEffect(() => {
        if (openChangeSignature) {
            handleOnClickAwayElement()
        }
    }, [openChangeSignature])

    const handleSendTempSignatureToParent = () => {
        sendTempSignatureToParent(element);
        setOpenAddSignature(true)
    }

    const handleOnMouseEnter = (isDraggable) => {
        console.log("handleOnMouseEnter bbbb", isDraggable);
        setIsDraggingUsingToolbarDragItem(true)
    }

    const handleDuplicateElement = () => {
        console.log("dri sugod click");
        setDuplicateElementData({isDuplicate: true, data: element})
    }

    const handleUpFontSize = () => {
        if (element.font_size >= 64) {
            setDisableUpFontSize(true)
        } else {
            setDisableDownFontSize(false)
            setTextElementFontSize({id: element.id, font_size: element.font_size + 2})
        }
    }

    const handleDownFontSize = () => {
        if (element.font_size <= 8) {
            setDisableDownFontSize(true)
        } else {
            setDisableUpFontSize(false)
            setTextElementFontSize({id: element.id, font_size: element.font_size - 2})
        }
    }

    const handleOpenChangeSignature = () => {
        openChangeSignatureFromParent(true)
        console.log("userId id aaa", element);
        setCurrentESignatureUserId(element.userId)
        setCurrentESignatureB2CId(element.b2c_id)
    }

    useEffect(() => {
        console.log("currentClickedElementId aa", currentClickedElementId);
    }, [currentClickedElementId])

    const actions = [
        {title: "Drag", type: 'dragElement', icon_component: <OpenWithIcon onMouseEnter={() => handleOnMouseEnter(true)} sx={{color: '#262626', cursor: 'all-scroll', height: 15, width: 15}}/>, 
        },

        {title: "Edit", type: 'edit', icon_component: <BorderColorOutlinedIcon onMouseEnter={() => handleOnMouseEnter(false)} sx={{color: '#262626', height: 15, width: 15}}/>, 
            onClick: () => handleOpenChangeSignature()
            // onClick: () => (element_type == "signature") ? handleSendTempSignatureToParent() : openChangeSignatureFromParent(true)
        },

        {title: "Duplicate", type: 'duplicate', icon_component: <ContentCopyIcon onMouseEnter={() => handleOnMouseEnter(false)} sx={{color: '#262626', height: 13, width: 13}}
            onClick={() => handleDuplicateElement()} />, 
        },

        {title: "Increase Font Size", type: 'upFontSize', icon_component: <Badge onClick={handleUpFontSize} onMouseEnter={() => handleOnMouseEnter(false)} badgeContent={<b style={{height: 5, marginLeft: 8}}> ▲</b>} 
            style={{backgroundColor: 'transparent', color: disableUpFontSize ? "#d1d1d1" : 'black'}}>
            <span style={{color: disableUpFontSize ? "#d1d1d1" : 'black', fontSize: 14}}>A</span>
        </Badge>, 
        },

        {title: "Decrease Font Size", type: 'downFontSize', icon_component: <Badge onClick={handleDownFontSize} badgeContent={<b style={{height: 5, marginLeft: 5}}> ▼</b>} 
            style={{backgroundColor: 'transparent', color: disableDownFontSize ? "#d1d1d1" : 'black'}}>
            <span style={{color: disableDownFontSize ? "#d1d1d1" : 'black', fontSize: 14}}>A</span>
        </Badge>, 
        },

        {title: "Delete", type: 'delete', icon_component: <DeleteOutlinedIcon onMouseEnter={() => handleOnMouseEnter(false)} sx={{color: '#262626', height: 15, width: 15}}/>, 
            onClick: () => removeElement()
        },
    ]

    return(
        // <Fade direction="up" in={true} mountOnEnter unmountOnExit>
        <Fade direction="up" in={currentClickedElementId == element.id} mountOnEnter unmountOnExit>
            <Box onMouseEnter={() => handleOnMouseEnter(false)} ref={elementToolbarRef} sx={{zIndex: 9999, bgcolor: "#fff", position:'absolute', mt: -4.8, borderRadius: '4px', boxShadow: '0px 4.8px 10.8px rgba(0,0,0,0.13908558841119492), 0px 0px 4.7px rgba(0,0,0,0.1176878055787034)'}}>
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={0}
                >
                    {
                    actions.map((action)=>{
                        if(action.type == 'edit' && element_type != elementTypes.userSignature) return null;
                        if(action.type == 'duplicate' && element_type == elementTypes.companySeal) return null
                        if(action.type == 'upFontSize' && element_type != elementTypes.textfield && element_type != elementTypes.date) return null
                        if(action.type == 'downFontSize' && element_type != elementTypes.textfield && element_type != elementTypes.date) return null
                        return(
                            <Tooltip key={action.title} title={action.title} arrow placement="top">
                                <IconButton disableRipple sx={{ "&:hover": {backgroundColor: "#fff", } }} onClick={action.onClick}>
                                    {action.icon_component}
                                </IconButton>
                            </Tooltip>
                        )
                    })}
                </Stack>
            </Box>
        </Fade>
    )
}

const PDFElementComponent = ({element, setCurrentElement, setHasElResizeStop, isViewing, openChangeSignatureFromParent, openChangeSignature, 
    setInputValue, setTextFieldValue, setHasElInputStop, templateProperties, setOpenAddSignature, sendTempSignatureToParent, 
    setElementResizedData, elementRef, setElementRef, parentRef, setElementUpdateValueData, setElementDeletedData, setDuplicateElementData, setTextElementFontSize,
    setCurrentESignatureUserId, setCurrentESignatureB2CId}) => {

    const url = window.location.pathname;

    const [isElementClicked, setIsElementClicked] = useState(false)
    const elRef = useRef()
    const elRef2 = useRef()
    const elementToolbarRef = useRef()
    const textParentRef = useRef()

    const [textfieldValue, setTextfieldValue] = useState(null);
    const [qrPreview, setQRPreview] = useState(null);
    const [currentClickedElementId, setCurrentClickedElementId] = useState(null);
    const [isDraggingUsingToolbarDragItem, setIsDraggingUsingToolbarDragItem] = useState(false);
    const [qrcodePreviewImg, setQrcodePreviewImg] = useState(null);
    const [elMaxConstraints, setElMaxConstraints] = useState({width: 0, height: 0, x: 0, y: 0});
    const [elMinConstraints, setElMinConstraints] = useState({width: 0, height: 0});
    const [imgDimens, setImgDimens] = useState(null);

    const {_debounce, data} = useDebounce(200)
    
    // handle QR Code
    useEffect(() => {
        if (element?.type == elementTypes.qrcode) {
            generateQR(element?.value);
        }
    },[JSON.stringify(element)])

    // useEffect(() => {
    //     var img = new Image();

    //     img.onload = function () {
    //     var canvas = document.createElement("canvas");
    //     var ctx = canvas.getContext("2d");

    //     let newWidth = 100
    //     let newHeight = 100

    //     canvas.width = newWidth;
    //     canvas.height = newHeight;

    //     ctx.drawImage(img, 0, 0, newWidth, newHeight);

    //     var resizedBase64 = canvas.toDataURL("image/png");
    //     setQrcodePreviewImg(resizedBase64);
    //     };

    //     img.src = qrcode;
    // }, [qrcode])

    useEffect(() => {
        console.log("isDraggingUsingToolbarDragItem 000", isDraggingUsingToolbarDragItem);
    }, [isDraggingUsingToolbarDragItem])
    
    const [{ isDragging1 }, dragRef] = useDrag(() => ({
        type: dragSourceType,
        item: {...element},
        end: (item, monitor) => {},
        collect: (monitor) => ({
            isDragging1: monitor.isDragging(),
          handlerId: monitor.getHandlerId(),
        }),
    }), [JSON.stringify(element)])

    const [{ isDragging },dragRef2, preview] = useDrag(() => ({
        type: dragSourceType,
        item: {...element, elementToolbarRef: elementToolbarRef},
        canDrag: (item, monitor) => {
            console.log("isDraggingUsingToolbarDragItem bbbb", isDraggingUsingToolbarDragItem);
            return isDraggingUsingToolbarDragItem
        },
        end: (item, monitor) => {},
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
          handlerId: monitor.getHandlerId(),
        }),
    }), [JSON.stringify(element), elementToolbarRef, isDraggingUsingToolbarDragItem])

    const opacity = isDragging ? 0.1 : 1
    const elDragRef = dragRef(elRef)
    const elDragRef2 = dragRef2(elRef2)

    useEffect(() => {
        console.log("element aabb", element);
        if (elDragRef2 != null) {
            setElementRef(elDragRef2)
        }
    }, [elDragRef2, JSON.stringify(element)])


    useEffect(() => {
        const parentRect = parentRef.current.getBoundingClientRect();

        if (elDragRef2.current) {
            const childRect = elDragRef2.current.getBoundingClientRect();
    
            if (element.type == elementTypes.textfield) {
                let maxWidth = (parentRect.right - childRect.right) + childRect.width
                let maxHeight = (parentRect.bottom - childRect.bottom) + childRect.height
                setElMaxConstraints({width: maxWidth, height: maxHeight})
                return;
            }
    
            let maxWidth, maxHeight;
            let rightDiff = parentRect.right - childRect.right;
            let bottomDiff = parentRect.bottom - childRect.bottom;
    
            maxWidth = rightDiff + childRect.width
            maxHeight = bottomDiff + childRect.height
    
            let hasCoordsChange = elMaxConstraints.x != childRect.x && elMaxConstraints.y != childRect.y ? true : false;
            if (hasCoordsChange) setElMaxConstraints({width: Math.floor(maxWidth), height: Math.floor(maxHeight), x: childRect.x, y: childRect.y})
        }
    }, [JSON.stringify(element), parentRef, elDragRef2])

    useEffect(() => {
        if (data)
            if(data.type == 'input_change') setElementUpdateValueData({id: element.id, value: data.value})
    }, [JSON.stringify(data)])

    // set min constraints for image elements (QRCode, UserSignature, Signatory)
    useEffect(() => {
        if (imgDimens) {
            let {width, height} = getElMinConstraints(imgDimens?.width, imgDimens?.height, true)
            setElMinConstraints({width, height})

            // reset el max constraints when updating image
            setElMaxConstraints({width: 0, height: 0})
        }
    }, [JSON.stringify(imgDimens)])

    // set minimum constraints for non image elements (Date, TextField)
    useEffect(() => {
        let elWidth, elHeight;

        if (element.type == elementTypes.date) {
            elWidth = initialDragElements.find((item) => item.type == elementTypes.date).width
            elHeight = initialDragElements.find((item) => item.type == elementTypes.date).height
        } else if (element.type == elementTypes.textfield) {
            elWidth = initialDragElements.find((item) => item.type == elementTypes.textfield).width
            elHeight = initialDragElements.find((item) => item.type == elementTypes.textfield).height
        } 
        let {width, height} = getElMinConstraints(elWidth, elHeight, false)
        setElMinConstraints({width, height})
    }, [])

    const getElMinConstraints = (origWidth, origHeight, hasAspectRatio) => {
        let minWidth, minHeight
        if (hasAspectRatio) {
            minWidth = getAdjustedWidth(minElementHeight, origWidth, origHeight)
            minHeight = getAdjustedHeight(minWidth, origWidth, origHeight)
        } else {
            minWidth = minElementWidth
            minHeight = minElementHeight
        }

        return {width: minWidth, height: minHeight}
    }

    const generateQR = async (value) => {
        let base64Img;
        let isURL = isValidURL(value)
        if (isURL) {
            base64Img = await generateQRCodeBase64(value);
        } else {
            base64Img = value
        }
        setQRPreview(base64Img);
    }


    const handleTextfieldChange = (e) => {
        console.log("on change aaaa");
        setTextfieldValue(e.target.value);
        _debounce({value: e.target.value, type: 'input_change'})
    }

    const onResizeStop = (event, {el, size, handle}) => {
        const childRect = elDragRef2.current.getBoundingClientRect();
        setElMaxConstraints({width: elMaxConstraints.width, height: elMaxConstraints.height, x: childRect.x, y: childRect.y})
        setElementResizedData({...element, w: size.width, h: size.height})
    };

    const handleResponsiveFontSize = () => {
        let defaultFontSize = 7
        let defaultParentWidth = 99 // TODO to create formula to result 99
        let parentCurrentWidth = textParentRef?.current?.clientWidth
        return getResponsiveFontSize(defaultFontSize, defaultParentWidth, parentCurrentWidth)
    }

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + '/' + mm + '/' + dd;

    const handleOnClickElement = () => {
        setCurrentClickedElementId(element.id)
    }

    const handleOnClickAwayElement = () => {
        setCurrentClickedElementId(null)
    }

    const handleRemoveElement = () => {
        handleOnClickAwayElement()
        setElementDeletedData({id: element.id})
    }

    const handleOnResizeStart = () => {
        setIsDraggingUsingToolbarDragItem(false)
    }

    const onResize = (event, {el, size, handle}) => {
        // for max constraints with maintained aspect ratio
        if (element.type == elementTypes.qrcode || element.type == elementTypes.userSignature || element.type == elementTypes.signature) {
            let sizeWidth = Math.floor(size.width)
            let sizeHeight = Math.floor(size.height)

            console.log("parentRef aaa1", parentRef);
            console.log("elDragRef2 aaa1", elDragRef2);
            
            if (parentRef.current != null) {
                const parentRect = parentRef.current.getBoundingClientRect();
                
                let rightDiff = parentRect.width - (element.x + element.w);
                let bottomDiff = parentRect.height - (element.y + element.h);
                
                let maxWidth = Math.floor(rightDiff + element.w)
                let maxHeight = Math.floor(bottomDiff + element.h)
                console.log("sizeWidth aaa", sizeWidth);
                console.log("maxWidth aaa", maxWidth);
                console.log("maxHeight aaa", maxHeight);
    
                if (sizeWidth >= maxWidth) {
                    let adjustedHeight = getAdjustedHeight(maxWidth, sizeWidth, sizeHeight)
                    setElMaxConstraints({width: maxWidth, height: Math.floor(adjustedHeight)})
                    return
                }
                if (sizeHeight >= maxHeight) {
                    let adjustedWidth = getAdjustedWidth(maxHeight, sizeWidth, sizeHeight)
                    setElMaxConstraints({width: Math.floor(adjustedWidth), height: maxHeight})
                    return
                }
            }
        }
    }

    const handleOnMouseEnter = (isDraggable) => {
        console.log("handleOnMouseEnter bbbb", isDraggable);
        setIsDraggingUsingToolbarDragItem(true)
    }

    const onLoadImg = (e) => {
        console.log("on load img aaa", e.target.width);
        setImgDimens({width: e.target.width, height: e.target.height})
    }

    const dateElementUI = () => {
        return(
            <>
                {
                    isViewing ?
                    <Grid item sx={{display: (element?.value) ? "visible" : "none"}}>
                        <Typography sx={{textAlign: "center", fontSize: element.font_size, fontFamily: 'Helvetica !important', lineHeight: 0.8}}>
                            {element?.value}
                        </Typography>
                    </Grid>
                    :
                    <ResizableBox
                        onMouseEnter={() => handleOnMouseEnter(true)}
                        className={'box'}
                        width={element?.w}
                        height={element?.h}
                        lockAspectRatio={false}
                        onResizeStop={onResizeStop}
                        axis={'both'}
                        onResizeStart={handleOnResizeStart}
                        onResize={onResize}
                        minConstraints={elMinConstraints.width > 0 && elMinConstraints.height > 0 ? [elMinConstraints.width, elMinConstraints.height] : null}
                        maxConstraints={elMaxConstraints.width > 0 && elMaxConstraints.height > 0 ? [elMaxConstraints.width, elMaxConstraints.height] : null}
                    >
                        <Typography sx={{textAlign: "start", ml: "2px", fontSize: element.font_size, fontFamily: 'Helvetica !important', lineHeight: 0.8}} 
                        >
                            {element?.value} 
                        </Typography>
                    </ResizableBox>
                }
            </>
        )
    }

    const textFieldElementUI = () => {
        return(
            <>
                {
                    isViewing ?
                    <Grid item sx={{display: (element?.value) ? "visible" : "none"}}>
                        <textarea
                            style={{
                                width: element?.w,
                                height: element?.h,
                                border: 'none',
                                resize: 'none',
                                outline: 'none',
                                color: "#1a1a1a",
                                backgroundColor: 'transparent',
                                fontSize: element.font_size,
                                fontFamily: 'Helvetica',
                                lineHeight: 0.95,
                                overflow: 'hidden',
                            }}
                            disabled
                            defaultValue={element?.value}
                        />
                    </Grid>
                    :
                    <ResizableBox
                        onMouseEnter={() => handleOnMouseEnter(true)}
                        className={'box'}
                        width={element?.w}
                        height={element?.h}
                        lockAspectRatio={false}
                        onResizeStop={onResizeStop}
                        axis={'both'}
                        onResizeStart={handleOnResizeStart}
                        onResize={onResize}
                        minConstraints={elMinConstraints.width > 0 && elMinConstraints.height > 0 ? [elMinConstraints.width, elMinConstraints.height] : null}
                        maxConstraints={elMaxConstraints.width > 0 && elMaxConstraints.height > 0 ? [elMaxConstraints.width, elMaxConstraints.height] : null}
                    >
                        <textarea
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                resize: 'none',
                                outline: 'none',
                                backgroundColor: "#0178f20f",
                                borderRadius: "5px",
                                color: "#1a1a1a",
                                fontSize: element.font_size,
                                fontFamily: 'Helvetica',
                                lineHeight: 0.95,
                            }}
                            autoFocus
                            defaultValue={element?.value}
                            onChange={(e) => handleTextfieldChange(e)}
                        />
                    </ResizableBox>
                }
            </>
        )
    }

    const companySealElementUI = () => {
        return(
            <>
                <Grid onMouseEnter={() => handleOnMouseEnter(true)} sx={{border: (isViewing) ? "" : "1px solid #0178f2", borderRadius: (isViewing) ? "" : "5px", width: element?.w, height: element?.h, 
                    pl: 0.8, pr: 0.8}} container spacing={0}>
                    <img alt="" src={OVCodeSealImg} style={{objectPosition: 'contain', width: '100%', height: '100%'}} />
                </Grid>
            </>
        )
    }

    const userSignatureElementUI = () => {
        return(
            <>
                <ResizableBox
                    onMouseEnter={() => handleOnMouseEnter(true)}
                    className={(isViewing) ? "box3" : `box ${isViewing && 'box3'}`}
                    width={element?.w}
                    height={element?.h}
                    lockAspectRatio={true}
                    onResizeStop={onResizeStop}
                    axis={`${isViewing ? 'none' : 'both'}`}
                    onResizeStart={handleOnResizeStart}
                    onResize={onResize}
                    minConstraints={elMinConstraints.width > 0 && elMinConstraints.height > 0 ? [elMinConstraints.width, elMinConstraints.height] : null}
                    maxConstraints={elMaxConstraints.width > 0 && elMaxConstraints.height > 0 ? [elMaxConstraints.width, elMaxConstraints.height] : null}
                >
                    <img alt="" 
                            onLoad={(e) => onLoadImg(e)}  
                            src={element?.value} style={{width: '100%', height: '100%', padding: 0, margin: 0,
                            objectFit: "contain"
                        }} 
                        />
                </ResizableBox>
            </>
        )
    }

    const qrcodeElementUI = () => {
        return(
            <>
                <ResizableBox
                    onMouseEnter={() => handleOnMouseEnter(true)}
                    className={(isViewing) ? "box3" : `box ${isViewing && 'box3'}`}
                    width={element?.w}
                    height={element?.h}
                    lockAspectRatio={true}
                    onResizeStop={onResizeStop}
                    axis={`${isViewing ? 'none' : 'both'}`}
                    onResizeStart={handleOnResizeStart}
                    onResize={onResize}
                    minConstraints={elMinConstraints.width > 0 && elMinConstraints.height > 0 ? [elMinConstraints.width, elMinConstraints.height] : null}
                    maxConstraints={elMaxConstraints.width > 0 && elMaxConstraints.height > 0 ? [elMaxConstraints.width, elMaxConstraints.height] : null}
                >
                    <img alt="" 
                        // ref={isViewing ? null : elDragRef} 
                        onLoad={(e) => onLoadImg(e)}  
                        src={qrPreview} style={{width: "100%", height: "100%", objectFit: "contain", padding: 0, margin: 0}} /> 
                </ResizableBox>
            </>
        )
    }

    const signatoryElementUI = () => {
        return(
            <>
                <ResizableBox
                    onMouseEnter={() => handleOnMouseEnter(true)}
                    className={(isViewing) ? "box3" : `box ${isViewing && 'box3'}`}
                    width={element?.w}
                    height={element?.h}
                    lockAspectRatio={true}
                    onResizeStop={onResizeStop}
                    axis={`${isViewing ? 'none' : 'both'}`}
                    onResizeStart={handleOnResizeStart}
                    onResize={onResize}
                    minConstraints={elMinConstraints.width > 0 && elMinConstraints.height > 0 ? [elMinConstraints.width, elMinConstraints.height] : null}
                    maxConstraints={elMaxConstraints.width > 0 && elMaxConstraints.height > 0 ? [elMaxConstraints.width, elMaxConstraints.height] : null}
                >
                    <img alt="" 
                            onLoad={(e) => onLoadImg(e)}  
                            src={element?.value} style={{width: '100%', height: '100%', padding: 0, margin: 0,
                            objectFit: "contain"
                        }} 
                        /> 
                </ResizableBox>
            </>
        )
    }

    return(
        <>
           {
            <ClickAwayListener onClickAway={handleOnClickAwayElement}>
                <Box sx={{position: 'absolute', left: element?.x, top: element?.y, opacity: isDragging ? 0 : 1, zIndex: 1}} ref={isViewing ? null : elDragRef2} onClick={handleOnClickElement}>
                    {/* Toolbar Menu */}
                    {!isViewing && 
                        <Grid container justifyContent="left">
                                <TemplateElementFloatingPanel element_type={element.type} removeElement={handleRemoveElement} isElementClicked={isElementClicked}
                                    openChangeSignatureFromParent={openChangeSignatureFromParent}
                                    openChangeSignature={openChangeSignature}
                                    setOpenAddSignature={setOpenAddSignature} element={element} isViewing={isViewing}
                                    sendTempSignatureToParent={sendTempSignatureToParent} 
                                    elDragRef2={elDragRef2} 
                                    currentClickedElementId={currentClickedElementId} isDraggingUsingToolbarDragItem={isDraggingUsingToolbarDragItem}
                                    setIsDraggingUsingToolbarDragItem={setIsDraggingUsingToolbarDragItem}
                                    isDragging={isDragging} elementToolbarRef={elementToolbarRef} setDuplicateElementData={setDuplicateElementData}
                                    setTextElementFontSize={setTextElementFontSize}
                                    handleOnClickAwayElement={handleOnClickAwayElement}
                                    setCurrentESignatureUserId={setCurrentESignatureUserId}
                                    setCurrentESignatureB2CId={setCurrentESignatureB2CId}
                                />
                        </Grid>
                    }

                    {/* Element */}
                    {
                        // User Signature element
                        element?.type == elementTypes.userSignature ?
                            userSignatureElementUI()
                        :
                        // Company Seal element
                        element.type == elementTypes.companySeal ?
                            companySealElementUI()
                        :
                        // Textfield element
                        element.type == elementTypes.textfield ?
                            textFieldElementUI()
                        :
                        // Date element
                        element.type == elementTypes.date ?
                            dateElementUI()
                        :
                        // QRCode element
                        element.type == elementTypes.qrcode ?
                            qrcodeElementUI()
                        :
                        // Signatory element
                        element.type == elementTypes.signature ?
                            signatoryElementUI()
                        :
                        null
                    }
                </Box>
            </ClickAwayListener>
           }
        </>
    )
}

export default PDFElementComponent